import { render, staticRenderFns } from "./PlayFriendItems.vue?vue&type=template&id=a0d6f18a&"
import script from "./PlayFriendItems.vue?vue&type=script&lang=js&"
export * from "./PlayFriendItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports